import { Box, Typography } from "@mui/material";

import fontWeight from "../../styles/mui/fontWeight";
import { colors } from "../../styles/colors";
import {
  Asterisk,
  ReadOnlyFieldContainer,
  ReadOnlyFieldIcon,
  ReadOnlyFieldLabel,
  ReadOnlyFieldValue,
} from "./styles/style";

type ReadOnlyFieldProps = {
  label: string;
  value: string | number;
  icon?: any;
  mandatorySymbol?: boolean;
  borderBottom?: boolean;
};

const ReadOnlyField = (props: ReadOnlyFieldProps) => {
  const { label, value, icon, mandatorySymbol, borderBottom } = props;
  return (
    <Box sx={ReadOnlyFieldContainer(borderBottom)}>
      <Box sx={ReadOnlyFieldLabel}>
        <Typography fontWeight={fontWeight.Weight[3]} color={colors.fonts[2]}>
          {label}
        </Typography>
        {mandatorySymbol && (
          <Typography
            variant="subtitle1"
            color={colors.red[90]}
            fontWeight={fontWeight.Weight[4]}
            pr={2}
            sx={Asterisk}
          >
            *
          </Typography>
        )}
      </Box>
      <Box sx={ReadOnlyFieldValue}>
        {icon && <Box sx={ReadOnlyFieldIcon}>{icon}</Box>}
        <Box color={colors.black[5]}>
          <Typography fontWeight={fontWeight.Weight[4]} lineHeight="1.3">
            {value || ""}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ReadOnlyField;
